<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h1 class="gradient-text">Financeiro</h1>
      <p>{{ 'auth.forgot_password_subtitle' | translate }}</p>
    </div>

    <div *ngIf="sent" class="success-message">
      <mat-icon>check_circle</mat-icon>
      <p>Se o email estiver cadastrado, voce recebera um link para redefinir sua senha.</p>
      <a routerLink="/login" mat-raised-button class="login-button full-width" style="margin-top: 16px;">
        {{ 'auth.login' | translate }}
      </a>
    </div>

    <form *ngIf="!sent" [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'auth.email' | translate }}</mat-label>
        <input matInput formControlName="email" type="email" autocomplete="email" />
        <mat-icon matPrefix>email</mat-icon>
        <mat-error *ngIf="form.get('email')?.hasError('required')">
          {{ 'auth.email_required' | translate }}
        </mat-error>
        <mat-error *ngIf="form.get('email')?.hasError('email')">
          {{ 'auth.email_invalid' | translate }}
        </mat-error>
      </mat-form-field>

      <button
        mat-raised-button
        class="login-button full-width"
        type="submit"
        [disabled]="form.invalid || loading"
      >
        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
        <span *ngIf="!loading">{{ 'auth.send_reset_link' | translate }}</span>
      </button>
    </form>

    <div class="login-footer">
      <a routerLink="/login">{{ 'common.back' | translate }}</a>
    </div>
  </div>
</div>
